import React from "react";
import LegalContent from "../../components/common/LegalContent";

export default function TermsAndConditions() {
  return <LegalContent type="terms" />;
}
